import React from 'react';

import { FightIcon } from '@vlabs/icons';
import { calculateProbabilityPercent } from '@vlabs/monokit/shared/lib/utils';
import { Tag } from '@vlabs/uikit';
import { useTranslation } from 'react-i18next';

import { BaseVideoAnalyticsDetails } from '../components/BaseVideoAnalyticsDetails';
import type { AnalyticDetailsEvent } from '../types';

type FightEvent = AnalyticDetailsEvent & {
  event: AnalyticDetailsEvent['event'] & {
    fight_bbox?: Record<string, unknown>;
    fight_score?: number;
  };
};

export function FightDetails({ event }: { event: FightEvent }): React.JSX.Element {
  const { t } = useTranslation();
  const score = calculateProbabilityPercent(event.event.fight_score);

  return (
    <BaseVideoAnalyticsDetails
      detections={event.event.fight_bbox ? [event.event.fight_bbox] : []}
      detectionSettingsLabel={t('videoAnalytics:fightAnalyticDetails.workspace.detection switch.label')}
      detectionType="bbox"
      event={event}
      tags={(
        <Tag
          data-testid="workspace.analyticEventDetails.extraTagType"
          icon={<FightIcon />}
          kind="neutral"
          size="large"
          value={`${t('videoAnalytics:fightAnalyticDetails.workspace.tag.label')} ${score}%`}
        />
      )}
      title={t('videoAnalytics:fightAnalyticDetails.workspace.title')}
    />
  );
}
